import React from 'react';

import * as Styled from './WebGLDisabled.styles';

const WebGlDisabled = () => (
  <Styled.Wrapper>This website needs WebGL to work properly</Styled.Wrapper>
);

export default WebGlDisabled;
